import { render, staticRenderFns } from "./FindTheWords.vue?vue&type=template&id=a848176e&"
import script from "./FindTheWords.vue?vue&type=script&lang=js&"
export * from "./FindTheWords.vue?vue&type=script&lang=js&"
import style0 from "./FindTheWords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FindTheWords.vue"
export default component.exports